<div class="breadcrumb-container mb-3">
    <div class="breadcrumb-wrapper">
        <div class="leftWrapper">
            <a (click)="returnOrigin()" class="back-button">
                <i class="bi-solid bi-arrow-left"></i>
            </a>
            <div class="breadcrumb-text">
                <p class="breadcrumb">{{origin}} / <span class="inactive">{{title}}</span></p>
                <h2 class="title">{{title}}</h2>
            </div>
        </div>
        <button *ngIf="showAddButton" (click)="onButtonClick()" class="btn btn-primary">Toevoegen</button>
    </div>
</div>